export { default } from "./ViewSharedLabel";
